export default __webpack_public_path__ + "static/media/Frame_2528-min_3.bc857d24.png";